import { ArrowBackOutlined, RemoveRedEyeOutlined } from "@material-ui/icons";
import {
  Button,
  CardHeader,
  Grid,
  IconButton,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import useToast from "../../../../../hooks/useToast";
import useConfirm from "../../../../../hooks/useConfirm";
import AuthService from "../../../../../service/AuthService";
import { CVService } from "../../../../../service/CVService";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import Formservice from "../../../../../service/Formservice";

const ConsultantList = ({ selection = false, id_type, handleSelectedCV }) => {
  const [cvLists, setCVList] = useState([]);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleGoBack = () => {
    navigate(-1);
  };

  const hanldeFetchOffreCOnsultant = () => {
    Formservice.getOffreExterneList({}).then((res) => {
      if (res && res.data) {
        setCVList(res.data);
      }
    });
  };

  const handleEditCV = (id) => {
    if (selection)
      AuthService.navigate(`/mon-profile/cv?id_identite=${id}`, selection);
    else navigate(`/mon-profile/cv?id_identite=${id}`);
  };
  const handleFetchCVList = () => {
    CVService.getCVList(filtre).then((res) => {
      if (res && res.data) {
        setCVList(res.data);
      }
    });
  };

  const handleUseCV = (id_type, identite) => {
    handleSelectedCV(id_type, identite);
  };

  const duplicateCV = (id_type, id_identite) => {
    openConfirmDialog("Confirmation", "Voullez vous dupliquer ce CV?", () => {
      handleDuplicateCV(id_type, id_identite);
    });
  };

  const handleDuplicateCV = (id_type, id_identite) => {
    CVService.duplicateCV(id_type, id_identite).then((res) => {
      if (res && res.success) {
        handleFetchCVList();
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const table_colonne = [
    {
      field: "file_cv",
      headerName: "Fichier",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "Date_creation",
      headerName: "Date de création",
      flex: 0.5,
      minWidth: 150,
    },
    /* {
      field: "email",
      headerName: "Adresse email",
      flex: 1,
      minWidth: 150,
    }, */
    {
      field: "reference",
      headerName: "Réference",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Dupliquer cv"
              color="secondary"
              onClick={(e) => duplicateCV(0, params.row.id_identite)}
            >
              <ContentCopyIcon />
            </IconButton>
            {/* <IconButton
              title="Modifier cv"
              color="primary"
              onClick={(e) => handleEditCV(params.row.id_identite)}
            >
              <EditOutlined />
            </IconButton> */}
            <IconButton
              title="Afficher cv"
              color="primary"
              onClick={(e) => handleEditCV(params.row.id_identite)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            {selection && (
              <Button
                sx={{ ml: 0.5 }}
                disabled={params.row.id_type > 0}
                title="Utiliser ce cv"
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => handleUseCV(id_type, params.row)}
              >
                Utiliser
              </Button>
            )}
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchCVList();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Candidature consultants"
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <Button onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </Button>
              }
              action={
                <Grid>
                  <TextField
                    id="recherche"
                    fullWidth
                    size="small"
                    placeholder="Recherche"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
              }
            />
            <Grid container>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={cvLists}
                getRowId={(row) => row.id_identite}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default ConsultantList;
